import * as angular from 'angular';

import { ComponentDefinition, DefaultGridsterOptions, SelectorType, IShewhartWidgetConfiguration, IValueViewModel } from '../../../models';
import { IStoreService } from '../../../services';
import { StoreElement, Store } from '../../../stateManagement';
import { Unsubscribe } from 'redux';

class ShewhartStateController implements angular.IComponentController {
    configuration: IShewhartWidgetConfiguration;
    gridsterOptions: any;
    isLoading: boolean;
    item: { configuration: IShewhartWidgetConfiguration };
    loadingMessage: string;
    tagGuid: string;
    tagDefinition: any;
    tagVm: IValueViewModel;

    private _unsubscribe: Unsubscribe;

    static $inject = ['$state', 'storeService'];

    constructor(
        private _$state: angular.ui.IStateService,
        private _storeService: IStoreService
    ) {
    }

    $onInit() {
        this.gridsterOptions = DefaultGridsterOptions;
        this.tagGuid = this._$state.params['tagDefinitionGuid'];
        this.configuration = {
            guid: this.tagGuid,
            selectorType: SelectorType.tagDefinition
        };
        this.item = { configuration: this.configuration };

        this._unsubscribe = this._storeService.register(store => this.updateStore(store), [
            StoreElement.Tags, StoreElement.ValueViewModels
        ]);
    }

    $onDestroy() {
        this._unsubscribe();
    }

    updateStore(store: Store): void {
        this.tagDefinition = store.tags.dictionary[this.tagGuid];
        this.tagVm = store.valueViewModels.dictionary[this.tagGuid];

        const data = this._$state.current.data;
        if (data && data.breadcrumbs) {
            data.breadcrumbs.level4 = this.tagDefinition.name;
        }
    }
}

export const wtShewhartState: ComponentDefinition = {
    componentId: 'wtShewhartState',
    controller: ShewhartStateController,
    template: require('./shewhartState.component.html'),
    controllerAs: 'vm',
    bindings: {
    }
};
